import styled from 'styled-components';
import { query } from 'ui/styles/queries';

export const SpaceBetweenContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  ${query.phone`
    display: block;
  `}
`;
